module.exports = __webpack_public_path__ + "img/recognition_img.5033607f.png";